<template>
<div class="content">
<div id="AquacultureObject" class="top-row">

    <figure class="figure" v-for="(item, index) in items()" :key="index">
    <img @click="selectObject(item.text, item.route)" :title='item[lang]'
    :alt='item[lang]'
    :src="require(`@/assets/${item.url}`)"
    class="img-fluid" />
     <figcaption class="figure-caption text-center">
              {{item[lang]}}</figcaption>
     </figure>
    </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  created() {
    this.$say('3.ogg');
  },
  computed: {
    lang() {
      return this.$store.state.calc.currentLocale;
    },

  },
  methods: {
    ...mapActions('calc', ['setAquacultureObject']),
    selectObject(text, route) {
      this.setAquacultureObject(text);
      this.$router.push(route);
      this.$say(text);
    },
    items() {
      return this.$store.state.calc.selectedAquaculture;
    },
  },

};
</script>

<style scoped>
.top-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
}

img {
    padding:25px;
    height:250px;
    width:363px;
}
img:hover{
    cursor: pointer;
}
</style>
